/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const S1_SHIPS_WORKFLOW_AREA = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {areaName: 'Area 1',},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            0.1318359375,
                            50.20503326494332
                        ],
                        [
                            2.9443359375,
                            50.20503326494332
                        ],
                        [
                            2.9443359375,
                            51.83577752045248
                        ],
                        [
                            0.1318359375,
                            51.83577752045248
                        ],
                        [
                            0.1318359375,
                            50.20503326494332
                        ]
                    ]
                ]
            }
        }
    ]
};

export default S1_SHIPS_WORKFLOW_AREA;